module.exports = __webpack_public_path__ + "assets/img/sdwan-module9-3.1e2ff056.jpg";